import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { useStepIndex } from '../stepper/step-index.context';
import { useStepperConfig } from '../stepper/stepper-config.context';

import * as styles from './step.styles';

type Props = {
  children: ReactNode;
  className?: string;
  id?: string;
};

export const Step = ({ children, className, id }: Props) => {
  const theme = useTheme();
  const index = useStepIndex();
  const { stepsCount, inverse, variant } = useStepperConfig();

  const isLast = index === stepsCount;

  return (
    <div
      className={className}
      css={[
        styles.container,
        styles.variant[variant](theme),
        inverse && styles.inverse[variant],
        isLast && styles.last,
      ]}
      data-testid="step"
      id={id}>
      {children}
    </div>
  );
};
